import { set, mapValues, get } from 'lodash-es';
import FormGroup from '@maison/components/form/FormGroup.vue';
import SelectField from '@maison/components/form/fields/SelectField.vue';
import { getFeatureFlag, FEATURE_FLAG } from '@phoenix/helpers/feature-flag-helper';

export default {
  components: { SelectField, FormGroup },

  props: {
    fields: {
      type: Object,
      required: true,
    },
  },

  data() {
    const regionsAndDistricts = {
      HK: [
        'District.aberdeen',
        'District.admiralty',
        'District.apleichau',
        'District.causewaybay',
        'District.central',
        'District.chaiwan',
        'District.happyvalley',
        'District.kennedytown',
        'District.mid-levels',
        'District.northpoint',
        'District.pokfulam',
        'District.quarrybay',
        'District.saiwanho',
        'District.shaukeiwan',
        'District.sheungwan',
        'District.siusaiwan',
        'District.southerndistrict',
        'District.taikoo',
        'District.thepeak',
        'District.wanchai',
        'District.westerndistrict',
      ],
      KLN: [
        'District.cheungshawan',
        'District.clearwaterbay',
        'District.diamondhill',
        'District.homantin',
        'District.hunghom',
        'District.kowloonbay',
        'District.kowlooncity',
        'District.kowloontong',
        'District.kwuntong',
        'District.laichikok',
        'District.lamtin',
        'District.lokfu',
        'District.meifoo',
        'District.mongkok',
        'District.ngauchiwan',
        'District.ngautaukok',
        'District.sanpokong',
        'District.shamshuipo',
        'District.taikoktsui',
        'District.tokwawan',
        'District.tseungkwano',
        'District.tsimshatsui',
        'District.wongtaisin',
        'District.yaumatei',
        'District.yautong',
      ],
    };

    if (getFeatureFlag(FEATURE_FLAG.HK_NEW_FORM)) {
      regionsAndDistricts.NT = [
        'District.fanling',
        'District.kwaichung',
        'District.maonshan',
        'District.saikung',
        'District.shatin',
        'District.shamtseng',
        'District.sheungshui',
        'District.taipo',
        'District.tinshuiwai',
        'District.tsingyi',
        'District.tsuenwan',
        'District.tuenmun',
        'District.tungchung',
        'District.yuenlong',
      ];
      regionsAndDistricts.OI = [
        'District.cheklapkok',
        'District.cheungchau',
        'District.discoverybay',
        'District.lammaisland',
        'District.lantauisland',
        'District.mawan',
        'District.pengchau',
        'District.tungchung',
      ];
    } else {
      regionsAndDistricts.NT = [
        'District.cheklapkok',
        'District.cheungchau',
        'District.discoverybay',
        'District.fanling',
        'District.kwaichung',
        'District.lammaisland',
        'District.lantauisland',
        'District.maonshan',
        'District.mawan',
        'District.pengchau',
        'District.saikung',
        'District.shatin',
        'District.shamtseng',
        'District.sheungshui',
        'District.taipo',
        'District.tinshuiwai',
        'District.tsingyi',
        'District.tsuenwan',
        'District.tuenmun',
        'District.tungchung',
        'District.yuenlong',
      ];
    }

    return {
      regions: Object.keys(regionsAndDistricts).map((region) => ({
        value: region,
        label: this.$t(`Region.${region}`),
      })),
      districtsByRegions: mapValues(regionsAndDistricts, (districts) =>
        districts.map((district) => ({
          value: this.$t(district),
          label: this.$t(district),
        })),
      ),
    };
  },

  watch: {
    'fields.state.value'(value) {
      this.setDistrictOptions(value);
    },

    'fields.state': {
      handler(val) {
        if (val && val.options.length === 0) {
          this.setRegionsOptions(this.regions);
        }
      },
      deep: true,
      immediate: true,
    },

    'fields.address10': {
      handler(val) {
        if (val && val.options.length === 0 && this.fields.state.value) {
          this.setDistrictOptions(this.fields.state.value);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    setRegionsOptions() {
      set(this.fields.state, 'options', this.regions);
    },

    setDistrictOptions(state) {
      set(this.fields.address10, 'options', get(this.districtsByRegions, [state], []));
    },
  },
};
